import { HUGGINGFACE_PROVIDER } from "@/components/ModelParameters/constants";
import { mapProviderToDisplayName } from "@/components/ProviderDropdown/utils";
import { Model, Provider } from "@/queries/models";

export const getProviders = (providers: Provider[], isEdit: boolean) => {
  const providersToShow = isEdit
    ? providers.filter(provider => provider.name !== HUGGINGFACE_PROVIDER)
    : providers;

  return providersToShow.map(provider => ({
    label: mapProviderToDisplayName(provider.name),
    value: provider.name,
    id: provider.name,
  }));
};

export const getModels = (models: Model[]) =>
  models
    .filter(m => !m.is_internal && !m.display_name)
    .map(m => ({
      label: m.llm_model_name,
      value: m.llm_model_name,
      id: m.llm_model_name,
    }));

export const getIsModelExists = (models: Model[], modelName: string) =>
  models
    .filter(m => !m.is_internal)
    .map(m => m.display_name || m.llm_model_name)
    .includes(modelName);
